// The rail may only say "Populair voor {device}" over products actually filtered to that device; otherwise it stays generic.
(function () {
  'use strict';

  var PARAM = 'filter.p.m.custom.compatible_models';

  function parts(root) {
    return {
      title: root.querySelector('[data-cm-bs-retitle]'),
      cta: root.querySelector('[data-cm-bs-cta]'),
      grid: root.querySelector('.cm-bestsellers__grid'),
      min: parseInt(root.dataset.cmMin, 10) || 4,
      // curated rail: only the case slots follow the device; 0 = the whole grid is swapped (legacy collection loop)
      caseSlots: parseInt(root.dataset.cmBsDeviceSlots, 10) || 0,
      url: root.dataset.cmCollectionUrl || '/collections/all',
      searchUrl: root.dataset.cmSearchUrl,
    };
  }

  function neutralize(p) {
    if (p.title) {
      if (p.title.dataset.cmOriginal === undefined) p.title.dataset.cmOriginal = p.title.textContent;
      p.title.textContent = p.title.dataset.cmOriginal;
    }
    if (p.cta) p.cta.classList.add('hidden');
  }

  function deviceTitle(p, device) {
    if (p.title) p.title.textContent = p.title.dataset.cmBsRetitle.replace('%DEVICE%', device.name);
    if (p.cta) {
      p.cta.textContent = p.cta.dataset.cmBsCta.replace('%DEVICE%', device.name);
      p.cta.setAttribute('href', device.url || '#');
      p.cta.classList.remove('hidden');
    }
  }

  // B18: the device collection carries a bol-ranked list (custom.popular_products); the section render returns
  // up to 4 available cards from it. Fewer than the slots need -> the relevance search below still runs.
  function popularCards(device) {
    if (!device || !device.handle) return Promise.resolve([]);
    var url = '/collections/' + encodeURIComponent(device.handle) + '-hoesje?sections=cm-populair-device';
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : {}; })
      .then(function (json) {
        var html = json && json['cm-populair-device'];
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-cm-slot="case"]'));
      })
      .catch(function () { return []; });
  }

  function upgrade(root, device) {
    var p = parts(root);
    var fvs = device.fvs || [device.filterValue];
    var url = p.searchUrl + '?q=*&type=product&filter.v.availability=1';
    fvs.forEach(function (fv) { url += '&' + PARAM + '=' + encodeURIComponent(fv); });

    popularCards(device)
      .then(function (popular) {
        var want = p.caseSlots || p.min;
        if (popular.length >= want) return popular;
        return fetch(url)
          .then(function (res) { if (!res.ok) throw new Error('bestsellers-by-device fetch failed'); return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var applied = window.CMGridExtract.filterApplied(doc, PARAM, fvs);
            return applied ? window.CMGridExtract.findCards(doc) : [];
          });
      })
      .then(function (items) {
        var want = p.caseSlots || p.min;
        if (items.length < want) return;

        if (p.caseSlots) {
          var slots = p.grid.querySelectorAll('li[data-cm-slot="case"]');
          if (!slots.length || items.length < slots.length) return;
          if (!root.cmOriginalCases) root.cmOriginalCases = Array.prototype.map.call(slots, function (li) { return li.cloneNode(true); });
          Array.prototype.forEach.call(slots, function (old, i) {
            items[i].setAttribute('data-cm-slot', 'case');
            p.grid.replaceChild(items[i], old);
          });
        } else {
          p.grid.innerHTML = '';
          items.slice(0, p.min * 2).forEach(function (li) { p.grid.appendChild(li); });
        }
        deviceTitle(p, device);
      })
      .catch(function () {});
  }

  function restoreCases(root) {
    if (!root.cmOriginalCases) return;
    var p = parts(root);
    var slots = p.grid.querySelectorAll('li[data-cm-slot="case"]');
    Array.prototype.forEach.call(slots, function (li, i) {
      if (root.cmOriginalCases[i]) p.grid.replaceChild(root.cmOriginalCases[i].cloneNode(true), li);
    });
  }

  function watch(root, device) {
    neutralize(parts(root));
    if (root.cmObserver) root.cmObserver.disconnect();
    if (!device) { restoreCases(root); return; }
    var observer = new IntersectionObserver(
      function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        upgrade(root, device);
      },
      { rootMargin: '0px 0px 600px 0px' }
    );
    root.cmObserver = observer;
    observer.observe(root);
  }

  function run(device) {
    document.querySelectorAll('.cm-bestsellers[data-cm-collection-url]').forEach(function (root) {
      watch(root, device);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    run(window.CMDevice ? window.CMDevice.get() : null);
  });
  document.addEventListener('cm:device:change', function (event) {
    run(event.detail);
  });
})();

